// Duas entradas no mesmo endereço (ADR 0014): o mapa do lead (/mapa/<token>) não confere sessão nem
// carrega o app da equipe; o resto é o app da equipe. A escolha acontece antes de qualquer pedido à API.
import './styles.css';

if (window.location.pathname.startsWith('/mapa/')) {
  void import('./mapa/boot.tsx');
} else {
  void import('./app/boot.tsx');
}
